import React from 'react'
import * as Icons from '../../images/index'

export default function Input({ name }){
	const IconSVG = Icons[name] || null

	return(
		<IconSVG/>
	)
}